import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Center, Spinner, VStack } from '@chakra-ui/react';
import { CardCarousel, CardCarouselProps } from '@src/components/sco/CardCarousel';
import { TopControlTest } from '@src/components/sco/CardCarousel/Controls/TopControlTest';
import { VideoCard } from '@src/components/sco/Education/VideoLanding/VideoCard';
import { gql, gqlArgs, gqlVars } from '@src/lib/gql';
type VideoFeaturedProps = {
  keywords?: string;
  termSlugs?: string[];
  carouselProps?: CardCarouselProps;
};
export const VideoFeatured = props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = VideoFeatured.queries.videoLists(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.keywords || $[3] !== props.termSlugs) {
    t1 = {
      variables: {
        termSlugs: props.termSlugs,
        keywords: props.keywords
      }
    };
    $[2] = props.keywords;
    $[3] = props.termSlugs;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const videoQuery = useQuery(t0, t1);
  if (videoQuery.error) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <>Error</>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (videoQuery.loading || !videoQuery.data) {
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center><Spinner /></Center>;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [1, 1, 2, 3, 3, 4];
    t3 = {
      top: TopControlTest,
      bottom: false
    };
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  let t4;
  if ($[9] !== videoQuery.data?.videoLists) {
    t4 = videoQuery.data?.videoLists?.slice(4, 12).map(_temp);
    $[9] = videoQuery.data?.videoLists;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props.carouselProps || $[12] !== t4) {
    t5 = <VStack align="flex-start" width="full"><CardCarousel fade={false} spacing={8} title="Popular Videos" visibleCards={t2} controls={t3} {...props.carouselProps}>{t4}</CardCarousel></VStack>;
    $[11] = props.carouselProps;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
VideoFeatured.fragments = {
  VideoList: () => gql`
    fragment _ on VideoList {
      id
      slug
      featuredImage {
        id
        url(transformation: { image: { resize: { fit: max, width: 1000 } } })
      }
      shortDescription
      longDescription
      people {
        id
        firstName
        lastName
        title
        companyName
        companyLogo {
          id
          url
        }
        avatar {
          id
          url
        }
      }
      videos {
        id
        slug
        featuredImage {
          id
          url
        }
        videoPreviewUrl
      }
      title
      terms {
        id
        name
        slug
      }
    }
  `
};
VideoFeatured.queries = {
  videoLists: (props: VideoFeaturedProps) => {
    const vars = gqlVars({
      '$keywords: String': props.keywords,
      '$termSlugs: [String]': props.termSlugs?.length > 0
    });
    const where = gqlArgs({
      'where: ': {
        '_search: $keywords': props.keywords,
        'terms_some: { slug_in: $termSlugs }': props.termSlugs?.length > 0
      }
    });
    return gql`
      query ${vars} {
        videoLists(
          orderBy: publishedAt_DESC
          ${where}
        ) {
          ${VideoFeatured.fragments.VideoList()}
        }
      }
    `;
  }
};
function _temp(video) {
  return <VideoCard key={video.id} avatar={video.people[0].avatar?.url} companyLogo={video.people[0].companyLogo?.url} firstName={video.people[0].firstName} image={video.featuredImage?.url} lastName={video.people[0].lastName} title={video.title} url={`/videos/${video.slug}/${video.videos[0]?.slug}?play=1`} video={video.videos[0]?.videoPreviewUrl} />;
}